import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import formMixin from '../formMixin';
import get from 'lodash/get';
import set from 'lodash/set';
import pickBy from 'lodash/pickBy';
import keys from 'lodash/keys';
export default {
  name: 'NiotaClassicDevicetypesDownlinks',
  mixins: [formMixin],
  props: {
    deviceTypeId: {
      type: String,
      required: true
    },
    deviceTypeData: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      downlinks: [],
      encodingTypes: ['base16', 'base64', 'utf8'],
      formSaving: false,
      formFields: [{
        title: 'name',
        required: true
      }, {
        title: 'payload',
        required: true
      }, {
        title: 'encoding',
        required: false
      }],
      validDownlinks: false,
      invalidIndices: []
    };
  },
  computed: {
    formCardButtons() {
      return [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.save'),
        tooltip: this.$i18n_t('Common.save'),
        action: 'submit-form',
        valid: this.isIotHubManager ? this.validDownlinks : false
      }];
    }
  },
  watch: {
    deviceTypeData() {
      this.handleDownlinksConfig();
    }
  },
  created() {
    this.handleDownlinksConfig();
  },
  methods: {
    requiredRuleCheck(cElement) {
      return v => {
        const bothEmpty = !cElement.name && !cElement.payload && !cElement.encoding;
        if (bothEmpty) {
          return true;
        }
        return this.requiredRule[0](v);
      };
    },
    handleDownlinksConfig() {
      this.downlinks = get(this.deviceTypeData, 'properties.downlinks');
      if (!this.downlinks) {
        set(this.deviceTypeData, 'properties.downlinks', []);
        this.downlinks = get(this.deviceTypeData, 'properties.downlinks');
      }
      if (this.downlinks.length === 0) {
        // init downlinks
        this.addNewDownlink(0);
      }
      this.validate();
    },
    addNewDownlink(index) {
      this.downlinks.splice(index + 1, 0, {
        name: null,
        payload: null,
        encoding: 'base16',
        port: 1,
        gatewayId: ''
      });
      this.validate();
    },
    removeDownlink(index) {
      this.downlinks.splice(index, 1);
      this.validate();
    },
    saveDownlinks() {
      set(this.deviceTypeData, 'properties.downlinks', this.downlinks);
      this.formSaving = true;
      NiotaClassicApiService.deviceTypesUpdate(this.deviceTypeId, this.deviceTypeData, 'downlinks').then(() => {
        this.$snack(this.$i18n_t('NiotaClassic.DeviceTypes.snacks.downlinksSaved'), 'success');
      }).finally(() => {
        this.formSaving = false;
      }).catch(() => {
        this.$snack(this.$i18n_t('NiotaClassic.DeviceTypes.snacks.downlinksSaveFailed'), 'error');
      });
    },
    validate() {
      this.invalidIndices = keys(pickBy(this.downlinks, item => {
        return !item.name || !item.payload;
      }));
      this.validDownlinks = this.invalidIndices.length === 0;
    }
  }
};